/**
 * Human-readable labels for methodology / elected-method identifiers.
 */

const METHOD_LABELS: Record<string, string> = {
  bottom_up: 'bottom-up BI loss',
  top_down: 'top-down BI loss',
  reconciled: 'reconciled',
  bi_bottom_up: 'bottom-up BI loss',
  bi_top_down: 'top-down BI loss',
  bi_projection_trend: 'projection-trend BI loss',
};

/**
 * Convert a backend method_id or elected_method string into a short,
 * human-readable phrase.
 *
 * Examples:
 *   bi_bottom_up        → "bottom-up BI loss"
 *   bi_top_down         → "top-down BI loss"
 *   bi_projection_trend → "projection-trend BI loss"
 *   reconciled          → "reconciled"
 *   bi_some_new_method  → "some new method"   (fallback)
 */
export function humanizeMethodId(id: string): string {
  if (METHOD_LABELS[id]) return METHOD_LABELS[id];
  // Fallback: replace underscores with spaces, then strip a leading "bi "
  return id
    .replace(/_/g, ' ')
    .replace(/^bi\s+/, '');
}
